import React from 'react';
import './Loader.scss';

const Loader = (props) => {
    return (
        <div className="loader">
            {props.children}
        </div>
    );
};

export default Loader;